function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import PropTypes from 'prop-types';
var SiteCoreLink = function SiteCoreLink(props) {
  var classes = [].concat(_toConsumableArray(props.htmlAnchorElement.classList), _toConsumableArray(props.additionalClasses));
  var cleanHref = props.htmlAnchorElement.href.indexOf(window.location.origin) === 0 ? props.htmlAnchorElement.href.substr(window.location.origin.length) : props.htmlAnchorElement.href;
  if (cleanHref !== '/' && (window.location.pathname.indexOf("".concat(cleanHref, "/")) === 0 || window.location.pathname === cleanHref)) {
    classes.push('active');
  }
  return /*#__PURE__*/React.createElement("a", {
    onClick: props.onClick,
    title: props.htmlAnchorElement.title,
    href: props.htmlAnchorElement.href,
    className: classes.join(' ')
  }, React.Children.count(props.children) > 0 && props.children, React.Children.count(props.children) === 0 && props.htmlAnchorElement.textContent);
};
SiteCoreLink.propTypes = {
  htmlAnchorElement: PropTypes.instanceOf(HTMLAnchorElement).isRequired,
  onClick: PropTypes.func,
  additionalClasses: PropTypes.arrayOf(PropTypes.string)
};
SiteCoreLink.defaultProps = {
  onClick: function onClick() {},
  additionalClasses: []
};
var _SiteCoreList = function SiteCoreList(props) {
  var items = Array.prototype.slice.call(props.htmlUListElement.children);
  return /*#__PURE__*/React.createElement("ul", null, items.map(function (item) {
    var itemList = item.children.length === 2 ? item.children[1] : null;
    var classes = _toConsumableArray(item.classList);
    var itemLink = item.querySelector('a');
    return /*#__PURE__*/React.createElement("li", {
      key: classes.join('-'),
      className: classes.join(' ')
    }, /*#__PURE__*/React.createElement(SiteCoreLink, {
      htmlAnchorElement: itemLink,
      onClick: props.onClick
    }), itemList && /*#__PURE__*/React.createElement(_SiteCoreList, {
      htmlUListElement: itemList
    }));
  }));
};
_SiteCoreList.propTypes = {
  htmlUListElement: PropTypes.instanceOf(HTMLUListElement).isRequired,
  onClick: PropTypes.func
};
_SiteCoreList.defaultProps = {
  onClick: function onClick() {}
};
var SiteCoreImage = function SiteCoreImage(props) {
  return /*#__PURE__*/React.createElement("img", {
    className: props.image.class,
    alt: props.image.alt,
    src: props.image.src,
    width: props.image.width,
    height: props.image.height
  });
};
Image.propTypes = {
  image: PropTypes.instanceOf(HTMLImageElement).isRequired
};
var SiteCoreEditFrame = function SiteCoreEditFrame(props) {
  var looseFrameZone = props.element.querySelector('.scLooseFrameZone');
  var chromeData = looseFrameZone && looseFrameZone.querySelector('.scChromeData');
  if (looseFrameZone && chromeData) {
    return /*#__PURE__*/React.createElement("div", {
      className: looseFrameZone.classList.item(0),
      sc_item: looseFrameZone.getAttribute('sc_item')
    }, /*#__PURE__*/React.createElement("span", {
      className: chromeData.classList.item(0)
    }, chromeData.textContent), props.children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
};
SiteCoreEditFrame.propTypes = {
  element: PropTypes.instanceOf(HTMLElement).isRequired
};
export { _SiteCoreList as SiteCoreList, SiteCoreLink, SiteCoreImage, SiteCoreEditFrame };